// src/pages/UsuariosPage.js
import React, { useState, useEffect } from 'react';
import api from '../utils/api';

export default function UsuariosPage() {
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [form, setForm] = useState({ username: '', password: '', nombre_completo: '', rol: 'conductor' });
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  const cargar = () => {
    setLoading(true);
    api.get('/usuarios')
      .then(r => { setUsuarios(r.data.data || []); setLoading(false); })
      .catch(() => { setError('Error al cargar usuarios'); setLoading(false); });
  };

  useEffect(() => { cargar(); }, []);

  const handleToggle = async (id) => {
    await api.patch(`/usuarios/${id}/toggle`);
    cargar();
  };

  const handleSubmit = async () => {
    if (!form.username || !form.nombre_completo) {
      setMsg('Nombre completo y usuario son requeridos');
      return;
    }
    if (!isEditing && !form.password) {
      setMsg('La contraseña es requerida para un nuevo usuario');
      return;
    }
    
    setSaving(true);
    try {
      let r;
      if (isEditing) {
        r = await api.put(`/usuarios/${selectedUserId}`, form);
      } else {
        r = await api.post('/usuarios', form);
      }
      
      if (r.data.success) {
        setMsg(isEditing ? 'Usuario actualizado correctamente' : 'Usuario creado correctamente');
        setShowForm(false);
        setIsEditing(false);
        setSelectedUserId(null);
        setForm({ username: '', password: '', nombre_completo: '', rol: 'conductor' });
        cargar();
      } else {
        setMsg(r.data.message || 'Error al guardar usuario');
      }
    } catch (e) {
      setMsg(e.response?.data?.message || 'Error al guardar usuario');
    }
    setSaving(false);
  };

  const handleEditClick = (u) => {
    setForm({ username: u.username, password: '', nombre_completo: u.nombre_completo, rol: u.rol });
    setSelectedUserId(u.id);
    setIsEditing(true);
    setShowForm(true);
    setMsg('');
  };

  const handleDeleteClick = async (id) => {
    if (window.confirm('¿Está seguro que desea eliminar este usuario de forma permanente?')) {
      try {
        await api.delete(`/usuarios/${id}`);
        cargar();
      } catch (err) {
        alert(err.response?.data?.message || 'Error al eliminar usuario');
      }
    }
  };

  const s = {
    page: { padding: 24 },
    header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 },
    title: { fontSize: 22, fontWeight: 700, margin: 0 },
    btn: { background: '#1890ff', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 18px', cursor: 'pointer', fontWeight: 600 },
    btnSm: { border: 'none', borderRadius: 4, padding: '4px 12px', cursor: 'pointer', fontSize: 12, fontWeight: 600 },
    table: { width: '100%', borderCollapse: 'collapse', background: '#fff', borderRadius: 8, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.1)' },
    th: { background: '#fafafa', padding: '12px 16px', textAlign: 'left', fontWeight: 600, borderBottom: '1px solid #f0f0f0', fontSize: 13 },
    td: { padding: '12px 16px', borderBottom: '1px solid #f0f0f0', fontSize: 13 },
    form: { background: '#fff', padding: 24, borderRadius: 8, boxShadow: '0 1px 4px rgba(0,0,0,0.1)', marginBottom: 20 },
    input: { width: '100%', padding: '8px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14, boxSizing: 'border-box' },
    label: { display: 'block', marginBottom: 4, fontWeight: 600, fontSize: 13 },
    grid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 },
  };

  return (
    <div style={s.page}>
      <div className="responsive-header">
        <h1 style={s.title}>Gestión de Usuarios</h1>
        <button style={s.btn} onClick={() => { 
          setShowForm(!showForm); 
          setIsEditing(false);
          setSelectedUserId(null);
          setForm({ username: '', password: '', nombre_completo: '', rol: 'conductor' });
          setMsg(''); 
        }}>
          {showForm ? 'Cancelar' : '+ Nuevo Usuario'}
        </button>
      </div>

      {msg && (
        <div style={{ padding: '10px 16px', borderRadius: 6, marginBottom: 16, background: msg.includes('correctamente') ? '#f6ffed' : '#fff2f0', border: `1px solid ${msg.includes('correctamente') ? '#b7eb8f' : '#ffccc7'}`, color: msg.includes('correctamente') ? '#135200' : '#a8071a' }}>
          {msg}
        </div>
      )}

      {showForm && (
        <div style={s.form}>
          <h3 style={{ marginTop: 0, marginBottom: 16 }}>{isEditing ? 'Editar Usuario' : 'Nuevo Usuario'}</h3>
          <div className="responsive-grid-2">
            <div>
              <label style={s.label}>Nombre completo *</label>
              <input style={s.input} value={form.nombre_completo} onChange={e => setForm({ ...form, nombre_completo: e.target.value })} placeholder="Ej: Juan Pérez García" />
            </div>
            <div>
              <label style={s.label}>Usuario *</label>
              <input style={s.input} value={form.username} onChange={e => setForm({ ...form, username: e.target.value })} placeholder="Ej: jperez" disabled={isEditing} title={isEditing ? 'El nombre de usuario no se puede cambiar' : ''} />
            </div>
            <div>
              <label style={s.label}>{isEditing ? 'Nueva Contraseña' : 'Contraseña *'}</label>
              <input style={s.input} type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} placeholder={isEditing ? "Dejar en blanco para no cambiar" : "Mínimo 6 caracteres"} />
            </div>
            <div>
              <label style={s.label}>Rol *</label>
              <select style={s.input} value={form.rol} onChange={e => setForm({ ...form, rol: e.target.value })}>
                <option value="conductor">Conductor</option>
                <option value="admin">Administrador</option>
              </select>
            </div>
          </div>
          <button style={s.btn} onClick={handleSubmit} disabled={saving}>
            {saving ? 'Guardando...' : (isEditing ? 'Actualizar Usuario' : 'Crear Usuario')}
          </button>
        </div>
      )}

      {loading ? (
        <div style={{ textAlign: 'center', padding: 40, color: '#999' }}>Cargando usuarios...</div>
      ) : error ? (
        <div style={{ color: 'red', padding: 20 }}>{error}</div>
      ) : (
        <div className="responsive-table-container">
          <table style={s.table}>
            <thead>
              <tr>
              <th style={s.th}>Nombre</th>
              <th style={s.th}>Usuario</th>
              <th style={s.th}>Rol</th>
              <th style={s.th}>Estado</th>
              <th style={s.th}>Creado</th>
              <th style={s.th}>Acción</th>
            </tr>
          </thead>
          <tbody>
            {usuarios.map(u => (
              <tr key={u.id}>
                <td style={s.td}>{u.nombre_completo}</td>
                <td style={s.td}><code>{u.username}</code></td>
                <td style={s.td}>
                  <span style={{ background: u.rol === 'admin' ? '#e6f7ff' : '#f6ffed', color: u.rol === 'admin' ? '#0050b3' : '#135200', padding: '2px 8px', borderRadius: 10, fontSize: 12, fontWeight: 600 }}>
                    {u.rol}
                  </span>
                </td>
                <td style={s.td}>
                  <span style={{ background: u.activo ? '#f6ffed' : '#fff2f0', color: u.activo ? '#135200' : '#a8071a', padding: '2px 8px', borderRadius: 10, fontSize: 12, fontWeight: 600 }}>
                    {u.activo ? 'Activo' : 'Inactivo'}
                  </span>
                </td>
                <td style={s.td}>{new Date(u.created_at).toLocaleDateString('es-PE')}</td>
                <td style={s.td}>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <button
                      style={{ ...s.btnSm, background: '#e6f7ff', color: '#0050b3' }}
                      title="Editar Usuario"
                      onClick={() => handleEditClick(u)}
                    >
                      ✏
                    </button>
                    <button
                      style={{ ...s.btnSm, background: u.activo ? '#fff2f0' : '#f6ffed', color: u.activo ? '#a8071a' : '#135200' }}
                      title={u.activo ? 'Desactivar' : 'Activar'}
                      onClick={() => handleToggle(u.id)}
                    >
                      {u.activo ? 'Desactivar' : 'Activar'}
                    </button>
                    <button
                      style={{ ...s.btnSm, background: '#fff1f0', color: '#cf1322', border: '1px solid #ffa39e' }}
                      title="Eliminar permanentemente"
                      onClick={() => handleDeleteClick(u.id)}
                    >
                      🗑
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      )}
    </div>
  );
}